import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { GROUPS } from "@/lib/options";

const HINT = { sizes: "mis. Regular +0, Large +5000", levels: "mis. Level 0, Level 1, Level 2 (harga boleh 0)", toppings: "mis. Keju +3000, Telur +4000 — klik Ada/Habis saat bahan kosong" };

const GroupEditor = ({ g, value, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  const edit = (i, k, v) => set({ items: value.items.map((it, j) => (j === i ? { ...it, [k]: v } : it)) });
  return (
    <div className="space-y-2 rounded-xl border border-slate-200 p-3" data-testid={`product-options-${g.key}`}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-slate-800">{g.label}</p>
        <Switch checked={value.enabled} onCheckedChange={(v) => set({ enabled: v })} data-testid={`product-options-${g.key}-toggle`} />
      </div>
      {value.enabled && (
        <>
          {!g.multi && (
            <label className="flex items-center gap-2 text-xs text-slate-600">
              <input type="checkbox" checked={value.required} onChange={(e) => set({ required: e.target.checked })} className="accent-emerald-600" data-testid={`product-options-${g.key}-required`} />
              Wajib pilih satu
            </label>
          )}
          <p className="text-xs text-slate-400">{HINT[g.key]}</p>
          {value.items.map((it, i) => (
            <div key={i} className={`grid gap-2 ${g.multi ? "grid-cols-[1fr_90px_auto_auto]" : "grid-cols-[1fr_110px_auto]"}`}>
              <Input maxLength={40} value={it.name} onChange={(e) => edit(i, "name", e.target.value)} placeholder="Nama" data-testid={`product-options-${g.key}-name-${i}`} />
              <Input type="number" min="0" value={it.price} onChange={(e) => edit(i, "price", e.target.value)} placeholder="+Rp" data-testid={`product-options-${g.key}-price-${i}`} />
              {g.multi && (
                <button type="button" onClick={() => edit(i, "available", it.available === false)} aria-pressed={it.available === false}
                  data-testid={`product-options-${g.key}-soldout-${i}`}
                  className={`rounded-md px-2 text-xs font-semibold transition-colors ${it.available === false ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-500 hover:bg-slate-200"}`}>
                  {it.available === false ? "Habis" : "Ada"}
                </button>
              )}
              <Button type="button" size="icon" variant="ghost" className="text-red-600" onClick={() => set({ items: value.items.filter((_, j) => j !== i) })} data-testid={`product-options-${g.key}-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
          {value.items.length < 15 && (
            <Button type="button" variant="outline" size="sm" onClick={() => set({ items: [...value.items, { name: "", price: "" }] })} data-testid={`product-options-${g.key}-add`}>
              <Plus className="mr-1 h-4 w-4" /> Tambah {g.label}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export const emptyGroup = (key) => ({ enabled: false, required: key !== "toppings", items: [] });

export const cleanGroups = (form) => Object.fromEntries(GROUPS.map(({ key }) => {
  const g = form[key] || emptyGroup(key);
  return [key, { ...g, items: g.items.filter((it) => it.name.trim()).map((it) => ({ name: it.name.trim(), price: Number(it.price) || 0, available: it.available !== false })) }];
}));

export const OptionsEditor = ({ form, setForm }) => (
  <div className="space-y-2" data-testid="product-options-editor">
    <p className="text-sm font-medium">Pilihan Tambahan (opsional)</p>
    {GROUPS.map((g) => (
      <GroupEditor key={g.key} g={g} value={form[g.key] || emptyGroup(g.key)} onChange={(v) => setForm((f) => ({ ...f, [g.key]: v }))} />
    ))}
  </div>
);
